import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { addAuthHeaders, apiPath } from '../../shared/api';
import { config } from '../../shared/config/transport';
import { CalendarObservation } from '../types/transport/calendar';

// Define a service using a base URL and expected endpoints
export const calendarApi = createApi({
  reducerPath: 'calendar',
  baseQuery: fetchBaseQuery({
    baseUrl: apiPath(config, '/calendar'),
    prepareHeaders: (h) => addAuthHeaders(config, h), // Adds msal auth headers
  }),
  endpoints: (builder) => ({
    getCalendar: builder.query<CalendarObservation[], {from?: string; to?: string} | void>({
      query: (data) => {
        const from = data?.from;
        const to = data?.to;
        return {
          url: '/',
          params: {
            from,
            to,
          },
        };
      },
    }),
  }),
});

export default calendarApi.reducer;

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetCalendarQuery: useCalendar } = calendarApi;
